import { render } from "./NaverConnectRedirectPage.vue?vue&type=template&id=85a46d18"
import script from "./NaverConnectRedirectPage.vue?vue&type=script&lang=js"
export * from "./NaverConnectRedirectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__